import styled from "styled-components";

import { fonts, setFontVariant } from "@similarweb/styles";
import { Tab } from "@similarweb/ui-components";

export const StyledTab = styled(Tab)`
    ${setFontVariant("tab")}
    font-family: ${fonts.$dmSansFontFamily} !important;
    font-weight: 700 !important;
    padding: 16px 24px 14px 24px;
`;
